import { GuardData } from './guard.model';

const authGuard = (guardData: GuardData): boolean => {
  return !!guardData.store.auth.user;
};

export default authGuard;
